export const fieldsProps = {
  role: {
    placeholder: 'Pilih Role',
    label: 'Role',
  },
};
